import React from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import './Layout.css';

export default function SiteLayout({ children }) {
  return (
    <div className="layout-root">
      <SiteHeader />
      <div className="layout-main">
        {children}
      </div>
      <SiteFooter />
    </div>
  );
}
